import {createFeatureSelector, createSelector} from '@ngrx/store';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';
import {State, stopRecordFeatureKey} from '../reducers/stop-record.reducer';

export const selectStopRecordState =
  createFeatureSelector<State>(stopRecordFeatureKey);

export const getStopRecord = createSelector(
  selectStopRecordState,
  (state: State): DvrRecord | null => state.record
);

export const getStopRecordLoaded = createSelector(
  selectStopRecordState,
  (state: State): boolean => state.loaded
);

export const getStopRecordLoading = createSelector(
  selectStopRecordState,
  (state: State): boolean => state.loading
);

export const getStopRecordError = createSelector(
  selectStopRecordState,
  (state: State): unknown => state.error
);
